const ANONYMOUS_ID_KEY = 'trvto_anonymous_id';

// crypto.randomUUID is missing on older iPhones (iOS < 15.4) and on
// non-HTTPS pages, and storage can throw in private mode — never crash.
export const makeId = () => {
    try {
        if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    } catch (e) {
        // fall through
    }
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
};

export const getAnonymousId = () => {
    try {
        let anonymousId = localStorage.getItem(ANONYMOUS_ID_KEY);

        if (!anonymousId) {
            anonymousId = makeId();

            localStorage.setItem(ANONYMOUS_ID_KEY, anonymousId);
        }

        return anonymousId;
    } catch (e) {
        return makeId();
    }
};
